import React from "react";

export default function SQL_Certificate() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Certificate</h1>
      <p>This is the SQL_Certificate component generated from the SQL JSON.</p>
    </div>
  );
}
